import React, { useContext } from "react";
import {
  Box,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  tableCellClasses,
  Button,
  Typography,
} from "@mui/material";
import moment from "moment";
import { toast } from "react-toastify";
import logo from "../assets/logo.png";

import { useStakingContract, useTokenContract } from "../ConnectivityAss/hooks";
import { AppContext, gasEstimationForAll } from "../utils";

function Record({ data, setloading, init }) {
  const { account, signer } = useContext(AppContext);

  const matches = useMediaQuery("(max-width:750px)");
  const stakingContract = useStakingContract(signer);
  // const tokenContract = useTokenContract(signer);

  const unStakeHandler = async (index) => {
    if (!account) {
      toast.error("Error! Please connect your wallet.");
    } else {
      try {
        setloading(true);
        const data = [index];
        const fn = stakingContract.estimateGas.withdraw;
        const tx = await stakingContract.withdraw(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
        toast.success("Success! Amount successfully unsataked.");
        init();
        setloading(false);
      } catch (err) {
        if (err?.data?.message) {
          toast.error(err?.data?.message);
        } else {
          toast.error(err?.message);
        }
        setloading(false);
      }
    }
  };

  return (
    <Box py={8}>
      <Container maxWidth={matches ? "xl" : "lg"}>
        <Box
          bgcolor="rgba(36, 0, 112, 0.2)"
          sx={{ backdropFilter: "blur(56px)" }}
          p={{ xs: 1, sm: 5 }}
        >
          <Box display="flex" justifyContent="center">
            <img src={logo} width="230px" height="62.19px" alt="" />
          </Box>
          <Box>
            <Box
              p={{ xs: 1, sm: 3 }}
              bgcolor="rgba(100, 73, 215, 0.1)"
              border="1px solid rgba(111, 100, 255, 0.45)"
              sx={{ backdropFilter: "blur(16px)" }}
              my={8}
            >
              <TableContainer>
                <Table
                  sx={{
                    borderCollapse: "separate",
                    borderSpacing: matches ? "10px" : "30px 10px",
                    [`& .${tableCellClasses.root}`]: {
                      borderBottom: "none",
                    },
                  }}
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontFamily: "Poppins",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: matches ? "12px" : "21px",

                          color: "#fff",
                        }}
                      >
                        Staked Amount
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Poppins",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: matches ? "12px" : "21px",
                          color: "#fff",
                        }}
                      >
                        Stake Time
                      </TableCell>

                      <TableCell
                        sx={{
                          fontFamily: "Poppins",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: matches ? "12px" : "21px",
                          color: "#fff",
                        }}
                      >
                        Reward
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Poppins",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: matches ? "12px" : "21px",
                          color: "#fff",
                        }}
                      >
                        Withdraw
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.length > 0 ? (
                      data.map(
                        (
                          {
                            stakedAmount: stakeAmount,
                            reward,
                            startTime: stakeTime,
                            endtime,
                            withdraw: withDrawn,
                          },
                          index
                        ) => (
                          <TableRow key={index}>
                            <TableCell
                              style={{
                                fontFamily: "Poppins",
                                fontStyle: "normal",
                                fontWeight: 400,
                                fontSize: matches ? "12px" : "21px",
                                color: "#fff",
                                backgroundColor: "#4600DA",
                              }}
                            >
                              {stakeAmount}
                            </TableCell>

                            <TableCell
                              style={{
                                fontFamily: "Poppins",
                                fontStyle: "normal",
                                fontWeight: 400,
                                fontSize: matches ? "12px" : "21px",
                                color: "#fff",
                                backgroundColor: "#4600DA",
                              }}
                            >
                              {moment
                                .unix(stakeTime)
                                .format("YYYY:MM:DD hh:mma")}
                            </TableCell>

                            <TableCell
                              style={{
                                fontFamily: "Poppins",
                                fontStyle: "normal",
                                fontWeight: 400,
                                fontSize: matches ? "12px" : "21px",
                                color: "#fff",
                                backgroundColor: "#4600DA",
                              }}
                            >
                              {reward.toFixed(4)}
                            </TableCell>

                            <TableCell
                              style={{
                                fontFamily: "Poppins",
                                fontStyle: "normal",
                                fontWeight: 400,
                                fontSize: matches ? "12px" : "21px",
                                color: "#fff",
                                backgroundColor: "#4600DA",
                              }}
                            >
                              <Button
                                variant="gradient"
                                to="/stake"
                                sx={{
                                  mt: 2,
                                  px: 8,
                                  fontWeight: 700,
                                  fontSize: "18px",
                                  textTransform: "capitalize",
                                  letterSpacing: "0.045em",
                                }}
                                disabled={
                                  +moment().format("X") < +endtime || withDrawn
                                    ? true
                                    : false
                                }
                                onClick={() =>
                                  unStakeHandler((index + 1).toString())
                                }
                              >
                                Withdraw
                              </Button>
                            </TableCell>
                          </TableRow>
                        )
                      )
                    ) : (
                      <TableRow>
                        <TableCell
                          style={{
                            fontFamily: "Poppins",
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: matches ? "12px" : "22.46px",
                            padding: "20px 0px",
                            borderBottom: "none",
                            color: "#fff",
                          }}
                          colSpan={5}
                          align="center"
                        >
                          You have no stake record yet.
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Record;
